import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import { msalInstance } from './auth/msal'
import { EventType } from '@azure/msal-browser'
import type { AccountInfo } from '@azure/msal-browser'
import { lightTheme, NConfigProvider } from 'naive-ui'
import naive from 'naive-ui'
import router from './router'
import App from './App.vue'
import './assets/styles/arag.css'
import './assets/styles/base.css'
import { uiOverrides } from '@/shared/uiOverrides.ts'
import { registerRoleDirective } from '@/shared/directives/role.directive.ts'
import { registerScrollShadowDirective } from '@/shared/directives/scrollShadow.directive.ts'

// Initiale MSAL instance and handle redirect
// handleRedirectPromise is needed if the login loginRedirect in Router is used
await msalInstance.initialize()
await msalInstance.handleRedirectPromise()

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    (event.payload as any).account !== undefined
  ) {
    const account = (event.payload as { account: AccountInfo }).account
    msalInstance.setActiveAccount(account)
  }
})

const app = createApp({
  render: () =>
    h(
      NConfigProvider,
      {
        theme: lightTheme,
        themeOverrides: uiOverrides,
      },
      {
        default: () => h(App),
      },
    ),
})

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(naive)

registerRoleDirective(app)
registerScrollShadowDirective(app)

app.mount('#app')
